import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { MSALInstanceFactory } from './app/shared/configs/msal.config';

// Initialize MSAL before bootstrapping the application
const msalInstance = MSALInstanceFactory();
msalInstance.initialize().then(() => {
  bootstrapApplication(App, appConfig).catch(err => console.error(err));
}).catch(err => {
  console.error('MSAL initialization failed:', err);
});
